import { createApi } from '@reduxjs/toolkit/query/react';
import {
  AboutClient,
  AboutTalent,
  ApiReportsResponse,
  GetJobsStatisticsResponse,
  JobData,
  JobDetailsData,
  JobSpecialityData,
} from '../../../types/reports';
import { baseQueryWithReauth } from '../baseQuery';

export const jobsReportsService = createApi({
  reducerPath: 'jobsReportsService',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getJobsStatistics: builder.query<GetJobsStatisticsResponse, void>({
      query: () => ({
        url: `/jobs/v1/job-statistics-report/stats`,
      }),
    }),
    getJobs: builder.query<ApiReportsResponse<JobData>, string>({
      query: (params) => ({
        url: `/jobs/v1/job-statistics-report?${params}`,
      }),
    }),
    getJobById: builder.query<JobDetailsData, string>({
      query: (id) => ({
        url: `/jobs/v1/operator-budget-reports/jobs/${id}`,
      }),
    }),
    getJobSpeciality: builder.query<JobSpecialityData, string>({
      query: (id) => ({
        url: `/jobs/v1/jobs/operator/${id}/category-speciality-skills`,
      }),
    }),
    getAboutClient: builder.query<AboutClient['payload'], string>({
      query: (id) => ({
        url: `/jobs/v1/operator/jobs/${id}/postActivities`,
      }),
      transformResponse: (response: AboutClient) => response.payload,
    }),
    getAboutTalent: builder.query
      <AboutTalent['payload'], { id: string; params: string }>({
        query: ({ id, params }) => ({
          url: `/jobs/v1/jobs/${id}/about-talent?${params}`,
        }),
        transformResponse: (response: AboutTalent) => response.payload,
      }),
    exportJobs: builder.query<any, { params: string; format: string }>({
      query: ({ params, format }) => ({
        url: `/jobs/v1/job-statistics-report/export-${format}?${params}`,
        responseHandler: async (response) => await response.blob(),
      }),
    }),
  }),
});

export const {
  useGetJobsStatisticsQuery,
  useGetJobsQuery,
  useGetJobByIdQuery,
  useGetJobSpecialityQuery,
  useLazyExportJobsQuery,
  useGetAboutClientQuery,
  useGetAboutTalentQuery,
} = jobsReportsService;
